import React from 'react';
import { TooltipInfoIcon } from 'common/tooltip-info-icon';
import { BreakdownDescriptionColumn } from './breakdown-description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const TaxableReceiptsBreakdownRow = ({ breakdown, providers }) => (
  <Row paddingBottom={'5px'}>
    <BreakdownDescriptionColumn>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {breakdown.label}
        {breakdown.infoText && <TooltipInfoIcon placement={'right'} text={breakdown.infoText} iconSize={'16px'} iconMargin={'0px 0px 0px 5px'} />}
      </div>
    </BreakdownDescriptionColumn>
    {providers.map((provider) => {
      const value = breakdown.providerValues.find((values) => values.providerID === provider.id)?.value || '';
      return <ProviderColumn key={`taxbleReceiptsBreakdown_${provider.id}`}>{value}</ProviderColumn>;
    })}
  </Row>
);
